import { createAsyncThunk } from "@reduxjs/toolkit";
import analyticsService from "../../../api/services/analytics";

export const getDetailedSiteAnalytics = createAsyncThunk(
  "analytics/get-detailed-site-analytics",
  async () => {
    return await analyticsService.getDetailedSiteAnalytics();
  }
);
